export default __webpack_public_path__ + "static/media/x-logo-fill.24d34f74.svg";